import { LEADERBOARD_ACTION } from '../../constants/actions'

const getLeaderboardData = () => ({
  type: LEADERBOARD_ACTION.GET_DATA
})

const getLeaderboardDataSuccess = (data) => ({
  type: LEADERBOARD_ACTION.GET_DATA_SUCCESS,
  payload: data
})

const getLeaderboardDataFailed = (error) => ({
  type: LEADERBOARD_ACTION.GET_DATA_FAILED,
  payload: error
})

export {
  getLeaderboardData,
  getLeaderboardDataSuccess,
  getLeaderboardDataFailed
}
